import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionBaseComponent } from '../userAction-base.component';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';

@Component({
  selector: 'userAction-setWawiSupplierPids',
  templateUrl: 'userAction-setWawiSupplierPids.component.html',
  styleUrls: ['userAction-setWawiSupplierPids.component.css'],
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionSetWawiSupplierPidsComponent) }
  ]
})
export class UserActionSetWawiSupplierPidsComponent extends UserActionBaseComponent {
  fillAlt: boolean = false;
  supplierIsManufacturer: boolean = false;
  newProductStatus: string = '';

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService
  ) {
    super(loginService, macroService);
  }

  catalogHasSupplier(): boolean {
    let value =
      this.catalogService.catalog?.supplier != null &&
      this.catalogService.catalog?.supplier?.supplierName != null &&
      this.catalogService.catalog?.supplier?.supplierName != '' &&
      this.catalogService.catalog?.supplier?.supplierId != null &&
      this.catalogService.catalog?.supplier?.supplierId != '';
    return value;
  }

  parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.fillAlt = parsed.FillAlt;
      this.supplierIsManufacturer = parsed.SupplierIsManufacturer;
      this.newProductStatus = parsed.NewProductStatus;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }

  createParameterStringAsJsonString(): string {
    return JSON.stringify({
      FillAlt: this.fillAlt,
      SupplierIsManufacturer: this.supplierIsManufacturer,
      NewProductStatus: this.newProductStatus
    });
  }
}
